import React from "react";
import { useParams } from "react-router-dom";
import { productDetails } from "../data";
import ProductSection from "../components/ProductSection";
function ProductTerms() {
  const { productName } = useParams();
  const selectedProduct = productDetails[productName];


  if (!selectedProduct) {
    return <p>Product not found</p>;
  }

  return (
    <div className="container max-w-3xl mx-auto py-10">
      <ProductSection title={`${selectedProduct.title} Terms and Conditions`} content={selectedProduct.termsAndConditions} />
    </div>
  );
}

export default ProductTerms;